<template>
  <div>
    <a-modal
      title="查看详情"
      :visible="visible"
      :mask-closable="false"
      :width="900"
      :confirm-loading="loading"
      destroy-on-close
      @cancel="handleCancel"
    >
      <template slot="footer">
        <a-button @click="handleCancel">
          关闭
        </a-button>
      </template>
      <a-form-model
        ref="form"
        :model="form"
        label-align="right"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 16 }"
        :rules="validateRules"
      >
        <a-row :gutter="24">
          <a-col :span="7">
            <a-form-model-item
              label="基地"
              prop="baseId"
            >
              <a-select
                v-model="form.baseId"
                placeholder="请先选择基地"
                allow-clear
                style="width: 180px;"
                show-search
                :filter-option="filterOption"
                @change="selectBase"
              >
                <a-select-option
                  v-for="item in baseOptions"
                  :key="item.baseId"
                >
                  {{ item.baseName }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item
              label="运营年度"
              prop="operatorYears"
            >
              <a-select
                v-model="form.operatorYears"
                placeholder="请选择运营年度"
                style="width: 180px;"
                mode="multiple"
                @select="selectProduct"
                @change="changeOperatorYears($event)"
              >
                <a-select-option
                  v-for="item in operatorYearsOptions"
                  :key="item"
                >
                  {{ item }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col
            v-if="visibleGrant"
            :span="7"
          >
            <span class="action_right">
              <TableActions
                :actions="headerActions"
                @exportResource="exportOperatorYearReleaseRecord"
              />
            </span>
          </a-col>
        </a-row>
        <div v-if="visibleGrant">
          <a-table
            :columns="columns"
            :data-source="dataSource"
            :loading="loading"
            :pagination="false"
            style="padding: 16px 0; background-color: #fff;"
            :row-key="(item, index) => index"
            :scroll="{ y: 940 }"
          >
            <template
              slot="startDate"
              slot-scope="startDate"
            >
              {{ moment(startDate).format('YYYY-MM-DD') }}
            </template>

            <template
              slot="endDate"
              slot-scope="endDate"
            >
              {{ moment(endDate).format('YYYY-MM-DD') }}
            </template>

            <template
              slot="recoveryDate"
              slot-scope="recoveryDate"
            >
              {{ recoveryDate? moment(recoveryDate).format('YYYY-MM-DD'): null }}
            </template>
          </a-table>
        </div>
      </a-form-model>
    </a-modal>
  </div>
</template>

<script>
import { queryAllReleaseRecord, exportOperatorYearReleaseRecord } from '@/api/baseDetail.js'
import { excelDown, filterOption } from '@/utils/utils'
import moment from 'moment'

import {
  queryBases,
  queryOperatorYears
} from '@/api/common.js'
const columns = [
  {
    title: '基地',
    dataIndex: 'baseName',
    key: 'baseName',
    width: '100px'
  },
  {
    title: '企业名称',
    dataIndex: 'enterpriseName',
    key: 'enterpriseName',
    width: '100px'
  },
  {
    title: '操作类型',
    dataIndex: 'operationTypeName',
    key: 'operationTypeName',
    width: '100px'
  },
  {
    title: '产品类型',
    dataIndex: 'productTypeName',
    key: 'productTypeName',
    width: '100px'
  },
  {
    title: '产品名称',
    dataIndex: 'productName',
    key: 'productName',
    width: '100px'
  },
  {
    title: '产品税率',
    dataIndex: 'taxRate',
    key: 'taxRate',
    width: '100px'
  },
  {
    title: '开通时间',
    dataIndex: 'startDate',
    key: 'startDate',
    width: '150px',
    scopedSlots: { customRender: 'startDate' }
  },
  {
    title: '到期时间',
    dataIndex: 'endDate',
    key: 'endDate',
    width: '150px',
    scopedSlots: { customRender: 'endDate' }
  },
  {
    title: '回收时间',
    dataIndex: 'recoveryDate',
    key: 'recoveryDate',
    width: '150px',
    scopedSlots: { customRender: 'recoveryDate' }
  },
  {
    title: '运营年度',
    dataIndex: 'operatorYear',
    key: 'operatorYear',
    width: '100px'
  },
  {
    title: '补贴金额',
    dataIndex: 'subsidyAmount',
    key: 'subsidyAmount',
    width: '100px'
  }
]
const headerActions = [
  {
    title: '导出',
    type: 'primary',
    action: 'exportResource',
    apis: ['@baseInfo/Export_Bases']

  }
]

export default {
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    dialogTitle: {
      type: String,
      default: null
    },
    baseId: {
      type: String,
      default: null
    }
  },
  data () {
    return {
      headerActions,
      loadingGrant: false,
      visibleGrant: false,
      confirmLoadingGrant: false,
      voucherVisible: false,
      otherVisible: false,
      productTypetions: [],
      baseOptions: [],
      form: {
        baseId: '',
        productTypeId: '',
        date: '',
        taxIncome: '',
        taxRate: '',
        remark: '',
        operatorYears: []
      },
      subsidyId: '',
      columns,
      dataSource: [],
      distributionAmount: '',
      operatorAmout: '',
      remainAmount: '',
      validateRules: {
        baseId: [{ required: true, message: '请选择基地', trigger: 'change' }],
        productTypeId: [{ required: true, message: '请输入产品类型' }],
        productId: [{ required: true, message: '请选择回款时间' }],
        enterpriseName: [{ required: true, message: '请选择企业名称' }],
        startDate: [{ required: true, message: '请选择开通时间' }],
        endDate: [{ required: true, message: '请选择结束时间' }]
      },
      isSelectBase: false,
      isSelectProduct: false,
      operatorYearsOptions: []
    }
  },
  watch: {
    visible: {
      deep: true,
      handler: function (data) {
        if (data) {
          this.fetchOptions()
          this.form.baseId = this.baseId
          this.operatorYearsOptions = []
          queryOperatorYears(
            {
              baseId: this.form.baseId
            }
          ).then((data) => {
            if (data) {
              this.isSelectBase = true
              this.operatorYearsOptions = data
            }
          })
        }
      }
    }
  },

  methods: {
    moment,
    excelDown,
    filterOption,
    handleCancel () {
      this.$emit('cancel')
      this.$refs.form.resetFields()
      this.visibleGrant = false
      this.isSelectProduct = false
      this.isSelectBase = false
    },
    async fetchOptions () {
      await queryBases().then((data) => {
        this.baseOptions = data
      })
    },
    async selectGrantResource (value1, value2) {
      if (value1 && value2) {
        await queryAllReleaseRecord(
          {
            baseId: this.form.baseId,
            operatorYears: this.form.operatorYears
          }
        ).then((data) => {
          this.visibleGrant = true
          this.dataSource = data
        })
      }
    },
    selectBase () {
      this.isSelectBase = true
      this.isSelectProduct = false
      this.visibleGrant = false
      this.operatorYearsOptions = []
      this.form.operatorYears = []
      this.selectGrantResource(this.isSelectProduct, this.isSelectBase)
      if (this.form.baseId) {
        queryOperatorYears(
          {
            baseId: this.form.baseId
          }
        ).then((data) => {
          this.operatorYearsOptions = data
        })
      }
    },
    selectProduct () {
      this.isSelectProduct = true
      this.selectGrantResource(this.isSelectProduct, this.isSelectBase)
    },
    async changeOperatorYears (e) {
      this.selectGrantResource(this.isSelectProduct, this.isSelectBase)
    },
    async exportOperatorYearReleaseRecord () {
      await exportOperatorYearReleaseRecord({
        baseId: this.form.baseId,
        operatorYears: this.form.operatorYears
      }).then((data) => {
        this.excelDown(data)
      })
    }
  }
}
</script>
<style lang="less" scoped>
.amountClass {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;

  .a-pad {
    margin: 20px 0 20px;
  }
}

/deep/ .ant-modal-content {
  max-height: 650px;
  overflow-y: auto;
}

.ant-form-item {
  margin-bottom: 14px;
}

.action_right{
  display: flex;
  justify-content: flex-end;
}
</style>
